import { AppState } from "store/rootReducer";
import { createSelector } from "reselect";

const adState = (state: AppState) => state.ad;

export const getAd = createSelector(adState, ({ ad }) => ad);

export const getAdStatus = createSelector(adState, ({ isProcessing, hasError }) => ({
    isProcessing,
    hasError,
}));
